import ko from '@tko/build.knockout';
import $ from 'jquery';

    function LyncFilterFormatter(params, observableOptions, dataSources) {

        var self = this;

        self.observableOptions = observableOptions; 

        self.dataSources = dataSources;

        self.sourcetype = params && params.type ? params.type : "";

        self.observableParams = dataSources[0].observableParams;

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function ComposeData(sourcetype, sourcelist, options, initFlag, dataProvider, params) {

        if (sourcetype == "LyncSessionsFlexQuery") {
            if ($.isEmptyObject(sourcelist)) {
                return {
                    callTypes: []
                };
            } else {
                return {
                    callTypes: sourcelist.Table
                };
            }

        } 

    }

    LyncFilterFormatter.prototype.RefreshData = function () {
        var self = this;

        self.sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.QueryResultDatasetDictionary, self.observableParams());

        if (self.sourceList != null)
            self.observableFormattedData(ComposeData(self.sourcetype, self.sourceList, self.observableOptions(), null, self.dataProvider, self.observableParams()));

    };

    LyncFilterFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    LyncFilterFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    LyncFilterFormatter.prototype.initialize = function (dataRepository, dataProvider) {
        var self = this;

        self.dataRepository = dataRepository;
        self.dataProvider = dataProvider;

        self.subscriptions.push(self.dataRepository.QueryResultDatasetDictionary.subscribe(function () { self.DataUpdated(); }));

        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(dataRepository.QueryResultDictionary()))
            self.RefreshData();
    };


    LyncFilterFormatter.prototype.getObservableData = function () {
        var self = this;

        return self.observableFormattedData;
    };

    LyncFilterFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default LyncFilterFormatter;
